<template>
    <div>
        <v-container>
            <v-layout>
                <v-flex class="hideInMobile">
                    <teacher-info style="background-color: white; margin-bottom: 5px"/>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-tabs left
                            next-icon="mdi-arrow-right-bold-box-outline"
                            prev-icon="mdi-arrow-left-bold-box-outline"
                            show-arrows
                            dark
                            v-model="activeTab"
                    >
                        <v-tabs-slider color="#2dfc80"></v-tabs-slider>
                        <v-tab key="myclass" @click="refreshTabClass" style="width: 150px;color: #2dfc80">
                            Lớp học
                        </v-tab>
                        <v-tab key="student" @click="refreshTabStudent" style="width: 150px;color: #2dfc80"
                               v-if="$store.state.auth.user.role==1">
                            Học viên
                        </v-tab>
                        <v-tab flat color="#00ab4d" key="teacher" @click="refreshTabTeacher"
                               style="width: 150px;color: #2dfc80" v-if="$store.state.auth.user.role==1">
                            Giáo viên
                        </v-tab>
                        <v-tab flat color="#00ab4d" key="account" @click="refreshTabProfile"
                               style="width: 150px;color: #2dfc80">
                            Tài khoản
                        </v-tab>
                        <v-tab-item key="myclass">
                            <my-class-component ref="myClassComponent"/>
                            <!--packet-component v-if="$store.state.auth.user.role==1"/-->
                            <div v-if="$store.state.auth.user.role==4 && $store.state.auth.user.roleList.indexOf('1')<0"
                                 style="text-align: center;background-color: white;margin-top: 10px;padding: 20px">
                                <div style="font-weight: bold">TÀI KHOẢN CỦA BẠN LÀ TÀI KHOẢN GIÁO VIÊN ĐƯỢC MỜI GIẢNG
                                    DẠY NÊN MỘT SỐ TÍNH NĂNG SẼ BỊ HẠN CHẾ.<br/> HÃY ĐĂNG KÝ ĐỂ TRỞ THÀNH TÀI KHOẢN GIÁO
                                    VIÊN ADMIN TRÊN YOCLASS ĐỂ QUẢN LÝ CÁC LỚP HỌC CỦA BẠN
                                </div>
                                <div class="primaryColor">Liên hệ với chúng tôi theo số <label
                                        style="font-weight: bold">097 967 8899</label> để được tư vấn & demo trực tiếp
                                    miễn phí giải pháp Yoclass
                                </div>
                                <!--v-btn dark class="yoprimary">Nâng cấp thành Giáo viên Admin</v-btn-->
                            </div>
                        </v-tab-item>
                        <v-tab-item key="student" v-if="$store.state.auth.user.role==1">
                            <student-component ref="studentComponent"/>
                        </v-tab-item>
                        <v-tab-item key="teacher" v-if="$store.state.auth.user.role==1">
                            <teacher-component ref="techerComponent"/>
                        </v-tab-item>
                        <v-tab-item key="account">
                            <Profile/>
                        </v-tab-item>

                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import MyClassComponent from "./MyClassComponent";
    import PacketComponent from "./PacketComponent";
    import StudentComponent from "./StudentComponent";
    import TeacherComponent from "./TeacherComponent";
    import Profile from "../Profile";
    import AppFooter from "../../components/layout/AppFooter";

    export default {
        components: {
            AppFooter,
            Profile,
            TeacherComponent, StudentComponent, PacketComponent, MyClassComponent, TeacherInfo, ClazzCreate
        },
        data() {
            return {
                activeTab: "myclass"
            }
        },
        created() {
        },
        beforeDestroy() {
        },
        methods: {
            refreshTabClass() {
                this.$refs.myClassComponent.searchClass();
            },
            refreshTabStudent() {
                this.$refs.studentComponent.init();

            },
            refreshTabTeacher() {
                this.$refs.techerComponent.init();

            },
            refreshTabProfile() {
                //this.$refs.myClassComponent.searchClass();
            },
        }
    };
</script>